import { useCallback, useState } from 'react';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';

import { useCreateSmartListAllowed } from './use-create-smart-list-allowed';

export const useCreateSmartListDialog = () => {
  const { allowed } = useCreateSmartListAllowed();
  const openPremiumDialog = useOpenPremiumDialog();
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    if (!allowed) {
      openPremiumDialog();
      return;
    }
    setIsOpen(true);
  }, [allowed, openPremiumDialog]);

  const close = useCallback(() => setIsOpen(false), []);

  return { open, isOpen, close };
};
